import { useDateFormat } from '@vueuse/core';
import { unixTimestampToDate } from '@dashboardApp/helpers/date';
import { sortObject } from './object';

/**
 * Find the sender from the message object
 */
export const messageSender = (message) => {
    let name = '';

    if (message.fromMember?._jv?.id) {
        if (message.fromMember.hasOwnProperty('supplier') && message.fromMember.supplier._jv?.id) {
            name = message.fromMember.supplier.contact_name || message.fromMember.supplier.name;
        } else {
            name = message.fromMember.first_name + ' ' + message.fromMember.last_name;
        }
    }
    if (!name || name.trim() === '') {
        name = 'Unknown User';
    }

    return name;
}

export const messageAvatar = (message) => {
    let avatar = '';

    if (message.fromMember?._jv?.id) {
        if (message.fromMember.hasOwnProperty('supplier') && message.fromMember.supplier._jv?.id) {
            avatar = message.fromMember.supplier.avatars['64x64'];
        } else {
            avatar = message.fromMember.avatar;
        }
    }
    return avatar;
}

/**
 * Find either the supplier name/avatar or member name/avatar for the message row usage
 * 
 * @see @dashboardApp/components/inbox/MessageRow.vue
 * @see @dashboardApp/components/directoryDashboard/InboxMessageRow.vue
 */
export const messageTitleAndAvatar = (message, currentUserId) => {
    let title = '';
    let avatar = '';

    if (message.toMember._jv.id && message.toMember._jv.id !== currentUserId) {
        if (message.toMember?.supplierContact && message.toMember.supplierContact._jv?.id) {
            title = message.toMember.supplierContact.contact_name || message.toMember.supplierContact.name;
            avatar = message.toMember.supplierContact.avatars['64x64'];
        } else if (message.toMember?.supplier && message.toMember.supplier._jv?.id) {
            title = message.toMember.supplier.contact_name || message.toMember.supplier.name;
            avatar = message.toMember.supplier.avatars['64x64'];
        } else {
            title = message.toMember.first_name + ' ' + message.toMember.last_name;
            avatar = message.toMember.avatar;
        }
    } else if (message.fromMember._jv.id) {
        if (message.fromMember?.supplierContact && message.fromMember.supplierContact._jv?.id) {
            title = message.fromMember.supplierContact.contact_name || message.fromMember.supplierContact.name;
            avatar = message.fromMember.supplierContact.avatars['64x64'];
        } else if (message.fromMember?.supplier && message.fromMember.supplier._jv?.id) {
            title = message.fromMember.supplier.contact_name || message.fromMember.supplier.name;
            avatar = message.fromMember.supplier.avatars['64x64'];
        } else {
            title = message.fromMember.first_name + ' ' + message.fromMember.last_name;
            avatar = message.fromMember.avatar;
        }
    }

    if (!title || title.trim() === '') {
        title = 'Unknown User';
    }

    return { title, avatar };
}

/**
 * Find the "from" details from the selected thread
 */
export const findThreadFrom = (thread, currentUserId) => {
    let id = 0;
    let name = '';
    let avatar = '';
    let supplier = {id: 0, slug: '', types: [], website: ''};
    let subject = '';
    let privateMsgUsername = ''; // phpbb username
    let privateMsgUserId = ''; // phpbb user ID

    const lastMsg = thread[Object.keys(thread).length - 1];

    if (!lastMsg) {
        return { id, name, avatar, supplier, subject, privateMsgUsername, privateMsgUserId };
    }

    subject = lastMsg.subject;

    if (lastMsg.toMember._jv.id && lastMsg.toMember._jv.id !== currentUserId) {
        id = lastMsg.toMember._jv.id;
        avatar = lastMsg.toMember.avatar;
        privateMsgUsername = lastMsg.to;
        privateMsgUserId = lastMsg.to_id;

        if (lastMsg.toMember.hasOwnProperty('supplier') && lastMsg.toMember.supplier._jv?.id) {
            name = lastMsg.toMember.supplier.contact_name || lastMsg.toMember.supplier.name;
            avatar = lastMsg.toMember.supplier.avatars['64x64'];
            supplier.id = lastMsg.toMember.supplier._jv.id;
            supplier.slug = lastMsg.toMember.supplier.slug;
            supplier.types = lastMsg.toMember.supplier.types;
            supplier.website = lastMsg.toMember.supplier.website;
        } else {
            name = lastMsg.toMember.first_name + ' ' + lastMsg.toMember.last_name;
        }

    } else if (lastMsg.fromMember._jv.id) {
        id = lastMsg.fromMember._jv.id;
        avatar = lastMsg.fromMember.avatar;
        privateMsgUsername = lastMsg.from;
        privateMsgUserId = lastMsg.from_id;

        if (lastMsg.fromMember.hasOwnProperty('supplier') && lastMsg.fromMember.supplier._jv?.id) {
            name = lastMsg.fromMember.supplier.contact_name || lastMsg.fromMember.supplier.name;
            avatar = lastMsg.fromMember.supplier.avatars['64x64'];
            supplier.id = lastMsg.fromMember.supplier._jv.id;
            supplier.slug = lastMsg.fromMember.supplier.slug;
            supplier.types = lastMsg.fromMember.supplier.types;
            supplier.website = lastMsg.fromMember.supplier.website;
        } else {
            name = lastMsg.fromMember.first_name + ' ' + lastMsg.fromMember.last_name;
        }
    }

    if (!name || name.trim() === '') {
        name = 'Unknown User';
    }

    return { id, name, avatar, supplier, subject, privateMsgUsername, privateMsgUserId };
}

export const groupToDatedMessages = (messages) => {
    let dateStr = '', groupedMessages = {};
    
    messages.sort((a, b) => a.date - b.date);
    for (const [, message] of Object.entries(messages)) {
        dateStr = useDateFormat(unixTimestampToDate(message.date), 'YYYY-MM-DD').value;

        if (!groupedMessages.hasOwnProperty(dateStr)) {
            groupedMessages[dateStr] = [];
        }
        groupedMessages[dateStr].push(message);
    }

    groupedMessages = sortObject(groupedMessages);
    return groupedMessages;
}

export const viewThread = (router, message, withReply = false) => {
    let name = !message.archived ? 'inbox-view' : 'inbox-archive-view';
    router.push({ name, params: { id: message._jv.id }, hash: (withReply ? '#reply' : '') })
}
